import { UserForm } from '@/components/auth/forms/user.form';
import { PhotoForm } from '@/components/auth/forms/photo.form';
import { CategoriesForm } from '@/components/auth/forms/categories.form';
import { CollegeCountryForm } from '../forms/college-country.form';
import { NhssaaView } from './nhssaa.view';
import { Slide } from './signup.types';
import { AccountStatus } from '@sportspredict/shared';

export const slides: Slide[] = [
	{
		id: 'user',
		title: 'Before we begin',
		description: "Let's get you set up!",
		Component: UserForm,
	},
	{
		id: 'photo',
		title: 'Add Your Personal Touch',
		description: 'Upload a photo to make your profile feel more you.',
		Component: PhotoForm,
	},
	{
		id: 'categories',
		title: 'What sports do you follow?',
		description: 'Select all that apply. This can be changed anytime in your account settings.',
		Component: CategoriesForm,
	},
];

export const probability_user_slide: Slide = {
	id: 'user',
	title: 'Before we begin',
	description: "Let's get you set up!",
	Component: UserForm,
};

export const probability_slides: Slide[] = [
	{
		id: 'college_country',
		title: 'Complete your profile',
		description: '',
		Component: CollegeCountryForm,
	},
];

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

interface GetActiveSignupSlidesParams {
	isProbabilityFlow: boolean;
	needsProbabilityUsername: boolean;
	// NHSSAA deep-link / change-parent-email: group is known up front, so the flow is
	// collapsed to the first slide + the consent step.
	isNhssaaFlow: boolean;
	// Any 14–16 minor (by age), regardless of group. Reaches consent after the normal
	// signup flow since age is only known mid-flow.
	requiresParentalConsent: boolean;
	isChangingParentEmail: boolean;
	accountStatus?: AccountStatus;
}

export function getActiveSignupSlides({
	isProbabilityFlow,
	needsProbabilityUsername,
	isNhssaaFlow,
	requiresParentalConsent,
	isChangingParentEmail,
	accountStatus,
}: GetActiveSignupSlidesParams): Slide[] {
	const baseSlides = isProbabilityFlow
		? needsProbabilityUsername
			? [probability_user_slide, ...probability_slides]
			: probability_slides
		: slides;

	// Approval activates the account. Profile completion must not restart consent.
	if (accountStatus === AccountStatus.Active) return baseSlides;

	const parentalConsentSlide: Slide = {
		id: 'nhssaa',
		title: isChangingParentEmail
			? 'Change parent email'
			: 'One more step,\na parent needs to say yes',
		description: isChangingParentEmail
			? 'Enter a new parent or guardian email address.'
			: 'Because you are or under 16 years of age,\na parent or guardian needs to approve your\naccount before you can participate.',
		Component: NhssaaView,
		buttonText: isChangingParentEmail ? 'Update email' : 'Send request',
	};

	// NHSSAA deep-link / change-parent-email: group is known up front, so the flow is
	// the first slide + the consent step.
	if (isNhssaaFlow) return [baseSlides[0], parentalConsentSlide];

	// Any other 14–16 minor reaches consent after the normal signup flow (age is only
	// known mid-flow, so append rather than collapse).
	if (requiresParentalConsent) return [...baseSlides, parentalConsentSlide];

	return baseSlides;
}
